import { Flex } from "@chakra-ui/react";
import { Button } from "newui/components/Button";
import { RfxTab } from "newui/features/Rfx/types/component-types";
import { Rfx } from "newui/features/Rfx/types/rfx.types";
import React from "react";
import { RFX_TABS } from "utils/constants";
import { useCurrentUser } from "hooks/auth";

interface RfxViewTabsProps {
	currentTab: RfxTab;
	isLoading?: boolean;
	rfxData: Rfx;
	setCurrentTab: (tab: RfxTab) => void;
}

const RfxViewTabs: React.FC<RfxViewTabsProps> = ({
	currentTab,
	setCurrentTab,
	rfxData,
	isLoading,
}) => {
	const documentationTotal = rfxData?.documentationDocument?.length || 0;

	const hasQuestionnaire =
		rfxData?.questionnaire?.length > 0 ||
		rfxData?.returnableScheduleType === "file";

	const isQuoteVisible = rfxData?.rfxType?.show_quote ?? true;
	const { currentUser } = useCurrentUser();
	const userId = currentUser?.id;

	const isApprover = rfxData?.rfxApprovers?.find(
		(approver) => approver.approverUserId === userId
	);

	if (currentTab === RFX_TABS.DOCUMENTATION && documentationTotal === 0) {
		setCurrentTab(RFX_TABS.QUESTIONNAIRE);
	}

	if (currentTab === RFX_TABS.QUESTIONNAIRE && !hasQuestionnaire) {
		setCurrentTab(RFX_TABS.QUOTE);
	}

	if (currentTab === RFX_TABS.QUOTE && !isQuoteVisible) {
		return null;
	}

	return (
		<div data-testid="preview-tabs">
			<Flex style={{ gap: "8px" }}>
				{documentationTotal !== 0 && (
					<Button
						className="inline-flex gap-2"
						btntype="tab"
						active={currentTab === RFX_TABS.DOCUMENTATION}
						onClick={() => setCurrentTab(RFX_TABS.DOCUMENTATION)}
						disabled={isLoading}
						data-testid="documentation-tab"
					>
						<span>Documentation</span>
					</Button>
				)}
				{hasQuestionnaire ? (
					<Button
						btntype="tab"
						active={currentTab === RFX_TABS.QUESTIONNAIRE}
						onClick={() => setCurrentTab(RFX_TABS.QUESTIONNAIRE)}
						disabled={isLoading}
						data-testid="returnable-schedules-tab"
					>
						Returnable Schedules
					</Button>
				) : null}
				{isQuoteVisible ? (
					<Button
						btntype="tab"
						active={currentTab === RFX_TABS.QUOTE}
						onClick={() => setCurrentTab(RFX_TABS.QUOTE)}
						disabled={isLoading}
						data-testid="quote-tab"
					>
						Quote
					</Button>
				) : null}
				{isApprover ? (
					<Button
						btntype="tab"
						active={currentTab === RFX_TABS.SUPPLIERS}
						onClick={() => setCurrentTab(RFX_TABS.SUPPLIERS)}
						disabled={isLoading}
						data-testid="supplier-list-tab"
					>
						Selected Suppliers
					</Button>
				) : null}
			</Flex>
		</div>
	);
};

export default RfxViewTabs;
